import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxV1 } from '@frontend/api-fax';
import { getUser } from '@frontend/auth-helpers';
import { useTranslation } from '@frontend/i18n';
import { useFaxTagNotification, useNotificationSettings } from '@frontend/notifications';
import { useAppScopeSelection } from '@frontend/scope';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxTagEventSubscription = () => {
  const { create } = useFaxTagNotification();
  const { t } = useTranslation('notifications');
  const { notificationSettings } = useNotificationSettings();
  const { updateFaxInListFaxCache } = FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();
  const user = getUser();
  const { selectedLocationIds } = useAppScopeSelection();

  return useWebsocketEventSubscription(NotificationType.FAX_TAG, (payload) => {
    // BE will send fax events to all users - location agnostic,
    // so we need to check if the event is relevant to the user's selected locations before processing it.
    if (!!payload.params.locationId && !selectedLocationIds.includes(payload.params.locationId)) {
      return;
    }

    updateFaxInListFaxCache({ faxId: payload.params.faxId, locationId: payload.params.locationId });
    // If the event is 'APPLIED' and the user is not the one who applied the tag, create a notification.
    if (payload.params.event === 'APPLIED' && payload.params.userId !== user?.userID) {
      const name = `${payload.params.contact?.firstName} ${payload.params.contact?.secondName}`;
      const notification = {
        id: payload.id,
        timestamp: Date.now(),
        type: 'fax-tag',
        payload: {
          ...payload.params,
        },
        state: {
          paused: false,
          timeout: notificationSettings.durationMs,
          status: 'unread',
        },
      } satisfies GetWeavePopNotificationByType<'fax-tag'>;
      create(notification, {
        os: {
          title: t('Fax'),
          body: `${name} ${payload.params.contact?.faxNumber}`,
        },
      });
    }
    return;
  });
};
